import { createSlice } from "@reduxjs/toolkit";

export interface GeneralState {
    darkMode:boolean
}
const initialState: GeneralState = {
    darkMode:false
}

const generalSlice = createSlice({
    name: "meeting",
    initialState,
    reducers: {
        setDarkMode: (state: GeneralState, action) => {
            state.darkMode = action.payload;
        },
       
    },

});

export const {setDarkMode } =
    generalSlice.actions;
export default generalSlice.reducer;